module.exports = __webpack_public_path__ + "static/media/5.20.98b4c571.png";